export const loadLiveChatComponent = async () => {
    const liveChatModule = await import('~/Partials/LiveChat/LiveChat');

    return liveChatModule.LiveChat;
};
